import colunasPadrao from "./colunas_padrao";
import form_padrao from "./form_padrao";

import helpers from "@/common/utils/helpers";

export default {
    "st" : {
        titulo : "Serviço de terceiro",
        endpoint : "servico-terceiro",
        nomeId : "servicoTerceiroId",
        nomeColunaTipo : "tipoServico",

        tipo : {
            label : "Tipo",
            options : helpers.getTipoServicos()
        },
        form : {
            tipoServico : null,
            ...form_padrao
        },
        colunas : [
            ...colunasPadrao,
        ]
    },
    "mc" : {
        titulo : "Material de consumo",
        endpoint : "material-consumo",
        nomeId : "materialConsumoId",
        nomeColunaTipo : "tipoMaterial",

        tipo : {
            label : "Tipo",
            options : helpers.getTipoMateriais()
        },
        form : {
            tipoMaterial : null,
            ...form_padrao
        },
        colunas : [
            ...colunasPadrao,
        ]
    },
    "mpe" : {
        titulo : "Materiais permanentes e equipamentos",
        endpoint : "material-permanente",
        nomeId : "materialPermanenteEquipamentoId",
        nomeColunaTipo : "tipoMaterial",

        tipo : {
            label : "Tipo",
            options : helpers.getTipoMateriaisPE()
        },
        form : {
            tipoMaterial : null,
            ...form_padrao
        },
        colunas : [
            ...colunasPadrao,
        ]
    },
    "vd" : {    
        titulo : "Viagens e diárias",
        endpoint : "viagem-diaria",
        nomeId : "viagemDiariaId",
        nomeColunaTipo : "tipoViagem",

        tipo : {
            label : "Tipo",
            options : helpers.getTipoViagens()
        },
        form : {
            propostaId: null,
            tipoViagem: null,
            detalhamento: null,
            justificativa: null,
            valorUnitario: 0,
            quantidade: null,
            valor: 0,
            mesDespesa: null
        },
        colunas : [
            { key: "detalhamento", label:"Detalhamento"},
            { key: "valorUnitario", label: "Custo unitário",
                formatter: (value) => {
                    if (value) return helpers.formatarValor(value);
                },
            },
            { key: "quantidade", label:"Quantidade"},
            { key: "valor", label: "Valor total",
                formatter: (value) => {
                    if (value) return helpers.formatarValor(value);
                },
            },
            { key: "actions", label: "Ações"} 
        ]
    },
    "ou" : {
        titulo : "Outros recursos",
        endpoint : "outro-recurso",
        nomeId : "outroRecursoId",
        nomeColunaTipo : "tipoRecurso",

        tipo : {
            label : "Tipo",
            options : helpers.getTipoRecursos()
        },
        form : {
            tipoRecurso : null,
            ...form_padrao
        },
        colunas : [
            ...colunasPadrao,
        ]
    }
}